import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './form-style.scss'
import { makeMerchantPayment } from '../../../services/transaction-service';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";

const inputSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([0-9]){0,5}/,
      'PIN should be numeric. No special characters allowed'
    ),
    clientCode: Yup.string()
    .min(6, 'OTP must have 6 digits')
    .max(6, 'OTP must have 6 digits')
    .matches(
      /^([0-9]{6})/,
      'Must have only 6 digits'
    )
    .required('Ce champs est obligatoire'),
});

const MerchantPaymentForm = ({ paymentRef }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [redirectUrl, setRedirectUrl] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    // console.log(`Submitting the following data ${JSON.stringify(values)}`);
    makeMerchantPayment(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You will be soon redirected`);
        setMessage(`${res.message} We will be redirecting you in about a minute`);
        if(res.data?.redirect_url?.length > 0){
          setRedirectUrl(res.data.redirect_url);
          // console.log('redirect url to go to', res.data.redirect_url);
        }
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  const handleReset = () => {
    setErrorMessage('');
    setMessage('');
    setFormSubmitted(false);
    setIsLoading(false);
  }

  useEffect(() => {
    if(redirectUrl != '')
      setTimeout( () => window.location.replace(redirectUrl), 10000);
  }, [redirectUrl]);

  return  (
    <div className="login-form">
      <div className='login-info'><h2>AFTA WALLET</h2></div>

      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className="login-warning">
        { errorMessage ? <button type="button" className='border-solid border-2 border-red-600 pt-1 pb-1 pl-2 pr-2' onClick={handleReset}>Try Again</button> : ''}
      </div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          clientCode: "",
          ref: paymentRef,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={inputSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            <div className={`field`}>
              <p>Fill the form to approve the payment.</p>
            </div>
            <div className={`field`}>
              <label htmlFor="clientCode">OTP</label>
              <input
                name="clientCode"
                id="clientCode"
                placeholder="OTP received"
                value={values.clientCode}
                onChange={handleChange}
              />
              {errors.clientCode && touched.clientCode ? (
                <div className="error">{errors.clientCode}</div>
              ) : ''}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN</label>
              <input
              type='password'
                name="pin"
                id="pin"
                max={5}
                min={5}
                placeholder="Wallet PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>APPROVE</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
          <BeatLoader
            color={Constant.spinner_color}
            loading={true}
            cssOverride={{
              textAlign: 'center',
              marginTop: '20px'
            }}
          />
        </p>
      }
    </div>
  );
};

export default MerchantPaymentForm;
